export const settings = {
  Settings: "설정",
  SettingsDesc: "설정을 변경하신 후 저장 버튼을 눌러주세요.",
  Theme: "테마",
  ToggleTheme: "테마 변경",
  LightTheme: "밝게",
  DarkTheme: "어둡게",
  SystemTheme: "시스템",
  Language: "언어",
  NotificationZero: "알림이 없습니다.",
  Install: "설치",
  Maintenance: "서비스 점검 중",
  Color: "색상",
} as const;
